import {
  CommandBar,
  DetailsHeader,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  IColumn,
  ICommandBarItemProps,
  IDetailsHeaderStyles,
  IDetailsListProps,
  IDetailsListStyles,
  IDetailsRowStyles,
  SelectionMode,
  Stack,
} from "@fluentui/react";
import { CSSProperties, useEffect, useState } from "react";
import themeBase from "../../utils/theme/themeBase";
import { LineProgress } from "../indicadores/Load";
interface ITableBase2 {
  style?: CSSProperties;
  rigthBar?: ICommandBarItemProps[];
  leftBar?: ICommandBarItemProps[];
  isLoading: boolean;
  data: any[];
  column: IColumn[];
  footerPagination?: JSX.Element | undefined;
}

export const TableBase2 = (props: ITableBase2) => {
  const [tableHeight, setTableHeight] = useState("50vh");
  const updateTableHeight = () => {
    const windowHeight = window.innerHeight;
    const newTableHeight = `${windowHeight * 0.8}px`;
    setTableHeight(newTableHeight);
  };
  useEffect(() => {
    updateTableHeight();
    window.addEventListener("resize", updateTableHeight);
    return () => {
      window.removeEventListener("resize", updateTableHeight);
    };
  }, []);

  const _tableStyle: Partial<IDetailsListStyles> = {
    root: {
      overflowX: "scroll",
      selectors: {
        "& [role=grid]": {
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          height: tableHeight,
        },
      },
    },
    headerWrapper: {
      margin: "0 0 1px 0",
      paddingTop: "0px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Cambia esto según tus necesidades
      flex: "0 0 auto",
    },
    contentWrapper: {
      flex: "1 1 auto",
      overflowY: "auto",
      overflowX: "hidden",
    },
  };
  return (
    <div style={props.style}>
      {(props.rigthBar || props.leftBar) && (
        <div className="ms-Grid-col ms-sm12 ms-lg12">
          <CommandBar
            items={props.leftBar ? props.leftBar : []}
            farItems={props.rigthBar}
            styles={themeBase.commadStyles}
          />
        </div>
      )}
      <Stack>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <LineProgress disabled={!props.isLoading} />
          {!props.isLoading && (
            <>
              <DetailsList
                items={props.data}
                compact={true}
                columns={props.column}
                selectionMode={SelectionMode.none}
                setKey="set"
                layoutMode={DetailsListLayoutMode.fixedColumns}
                isHeaderVisible={true}
                selectionPreservedOnEmptyClick={true}
                enterModalSelectionOnTouch={true}
                ariaLabelForSelectionColumn="Toggle selection"
                ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                checkButtonAriaLabel="select row"
                styles={_tableStyle}
                onRenderRow={_onRenderRow}
                onRenderDetailsHeader={_onRenderDetailsHeader}
              />
              {props.footerPagination && (
                <div
                  style={{
                    bottom: 0,
                  }}
                >
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    {props.footerPagination}
                    {/* <PaginationFooterC totalPaginas={30} /> */}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </Stack>
    </div>
  );
};
const _onRenderDetailsHeader: IDetailsListProps["onRenderDetailsHeader"] = (
  props
) => {
  const customStyles: Partial<IDetailsHeaderStyles> = {};
  customStyles.root = {
    paddingTop: "0px",
    textAlign: "",
  };
  if (props) {
    return <DetailsHeader {...props} styles={customStyles} />;
  }
  return null;
};

const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
  const customStyles: Partial<IDetailsRowStyles> = {};
  if (props) {
    customStyles.root = {
      width: "100%",
      margin: "0 0 0 0",
    };

    return <DetailsRow {...props} styles={customStyles} />;
  }
  return null;
};
